import { getAuth, signOut } from "firebase/auth";
import { clearLocalStorage } from "../LocalStorage/ClearLocalStorage";
const Logout = async () => {
  const auth = getAuth();
  return signOut(auth)
    .then(() => {
      clearLocalStorage();
      return true;
    })
    .catch((error) => {
      // An error happened.
      console.log("SMS: Logout.js Logout", error);
      return false;
    });
};

export default Logout;
